'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

ErrorHandlers=class ErrorHandlers extends BaseService{
constructor($state,$window,Analytics){
super();

this._analytics=Analytics;

this.onSessionExpired=()=>{





const authConfigName=_.get(this.currentUser,'authConfigName');

if(authConfigName){
$window.location=`/saml2/${authConfigName}/login`;
}else{
$state.go('fdc.features.login',{sessionHasExpired:!0,return_to:encodeURIComponent($window.location.href)});
}
};

this._handlers={
AppReloadRequiredError:()=>{
$window.location.reload(!0);
},
SessionExpiredError:()=>{
this.onSessionExpired();
},
AccessDeniedError:()=>{
$window.alert('Access denied, please contact your administrator.');
$window.location.reload(!1);
}};

}

handlerFor(error){
let constructorName=_.get(error,'constructor.name');

let handler;
if(_.exists(constructorName)){
handler=this._handlers[constructorName];
}

if(_.exists(handler)){
this._analytics.trackEvent('error','handled',constructorName);
}else{
let errorLabel=`${error.stack||error.description||error.message||error}`.replace(/[\r\n\t]+/g,' | ');
this._analytics.trackEvent('error','unhandled',errorLabel);
}

return handler;
}

get currentUser(){
return _.result(this,'getCurrentUser');
}};


module.exports=ErrorHandlers;
//# sourceMappingURL=errorHandlers.js.map
